export const colors = {
  // Colors
  primaryColor: '#F7931C',
  secondaryColor: '#0F2246',

  primaryBGColor: '#ffffff',
  secondaryBGColor: '#fde9d1',

  buttonTextColor: '#ffffff',

  iconPrimaryColor: '#ffffff',

  textPrimaryColor: '#000000',

  textSecondaryColor: '#545759',

  iconDefaultColor: '#bfbfbf',

  safeButtonColor: '#3DC793',

  borderColor: '#d9d9d9',

  medicalRequestReferenceColor: '#87d068',

  externalEngagementReferenceColor: '#108ee9',
};
